var H = Object.defineProperty;
var j = (e, l, t) => l in e ? H(e, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[l] = t;
var d = (e, l, t) => (j(e, typeof l != "symbol" ? l + "" : l, t), t);
import { format as h } from "@permafrost-dev/pretty-format";
import { Ray as U } from "node-ray/dist/web";
import { getCurrentInstance as g, watch as M, onBeforeMount as C, onBeforeUnmount as D, onUpdated as O, onMounted as W, onUnmounted as T, ref as V } from "vue";
const P = {
  NAME: "vue-ray",
  VERSION: "2.0.3"
}, N = (e) => {
  e.$rayMeta = P;
}, m = (e) => {
  const l = (e == null ? void 0 : e.name) ?? "unknown";
  let t = (e == null ? void 0 : e.__file) ?? "src/unknown.js";
  return l.length && l !== "unknown" ? l : (t = t.split("/").pop() ?? "unknown.js", t.replace(/\.[\w-_]+$/, ""));
}, u = (e, l, t = null) => {
  if (t = t ?? o.methods.$ray, l.type && (l = l.type), !((l == null ? void 0 : l.__file) ?? !1))
    return;
  const c = m(l);
  let n = t;
  typeof t == "function" && (n = t()), n.table([
    `component: <code class="text-green-600 font-bold bold">${c}</code>`,
    `lifecycle event: <code class="text-blue-600">${e}</code>`,
    `filename: <code class="text-gray-700">${(l == null ? void 0 : l.__file) ?? "unknown.js"}</code>`
  ]);
}, o = {
  beforeMount(e, l = null) {
    u("before-mount", e, l);
  },
  beforeUnmount(e, l = null) {
    u("before-unmount", e, l);
  },
  created(e, l = null) {
    u("created", e, l);
  },
  mounted(e, l = null) {
    u("mounted", e, l);
  },
  unmounted(e, l = null) {
    u("unmounted", e, l);
  },
  updated(e, l = null) {
    u("updated", e, l);
  },
  methods: {
    // eslint-disable-next-line
    $ray(e) {
      return k(e);
    }
  }
};
class y extends U {
  constructor() {
    super(...arguments);
    d(this, "component", { $data: {}, $refs: {} });
    d(this, "$watch", () => {
    });
  }
  data() {
    if (this.component) {
      let t = Object.assign({}, this.component.data);
      delete t.trackingRays, delete t.trackingStops, t = Object.freeze(t), this.table([t], "Data");
    }
  }
  props() {
    this.component && this.table([this.component.props]);
  }
  element(t) {
    var c, n;
    return (c = this.component) != null && c.refs[t] ? this.html(((n = this.component) == null ? void 0 : n.refs[t]).outerHTML) : this;
  }
  track(t) {
    if (this.component && typeof this.component.trackingRays[t] > "u") {
      this.component.trackingRays[t] = o.methods.$ray(this.component)(this.component.data.name);
      const c = (n, r) => {
        this.component.trackingRays[t] = this.component.trackingRays[t].sendCustom(
          [
            `<code style="font-weight: bold;">tracking: </code><code style="color: #16a34a;">${m(this.component.type)}.data.${t}</code>`,
            `<hr width="33%" align="left" /><code style="color: #94a3b8;">new value: </code><code class="text-gray-500 bold font-bold">${h(n)}</div>`,
            `                               <code style="color: #94a3b8;">old value: </code><code class="text-gray-700">${h(r)}</code>`,
            `<hr width="33%" align="left" /><code style="color: #94a3b8;">changed at: </code><code style="color: #60a5fa;">${(/* @__PURE__ */ new Date()).toISOString()}</div>`
          ].join("<br>"),
          "Tracking Data"
        );
      };
      this.component.trackingStops[t] = this.$watch(() => this.component.data[t], c, { deep: !0 });
    }
  }
  untrack(t) {
    this.component && typeof this.component.trackingStops[t] < "u" && (this.component.trackingStops[t](), delete this.component.trackingStops[t]), this.component && typeof this.component.trackingRays[t] < "u" && delete this.component.trackingRays[t];
  }
  unwatch(t) {
    this.component && typeof this.component.trackingStops[t] < "u" && (this.component.trackingStops[t](), delete this.component.trackingStops[t]), this.component && typeof this.component.trackingRays[t] < "u" && delete this.component.trackingRays[t];
  }
  watch(t, c) {
    if (this.component && typeof this.component.trackingRays[t] > "u") {
      this.component.trackingRays[t] = o.methods.$ray(this.component)(c.value);
      const n = (r, a) => {
        this.component.trackingRays[t] = this.component.trackingRays[t].sendCustom(
          [
            `<code style="font-weight: bold;">watching: </code><code style="color: #16a34a;">${m(this.component.type)} ➞ Ref&lt;${t}&gt;</code>`,
            `<hr width="33%" align="left" /><code style="color: #94a3b8;">new value: </code><code class="text-gray-500 bold font-bold">${h(r)}</div>`,
            `                               <code style="color: #94a3b8;">old value: </code><code class="text-gray-700">${h(a)}</code>`,
            `<hr width="33%" align="left" /><code style="color: #94a3b8;">changed at: </code><code style="color: #60a5fa" class="text-gray-500 bold font-bold">${(/* @__PURE__ */ new Date()).toISOString()}</div>`
          ].join("<br>"),
          "Watching Ref"
        );
      };
      this.component.trackingStops[t] = this.$watch(c, n, { deep: !0 });
    }
  }
  static useDefaultSettings(t) {
    return super.useDefaultSettings(t);
  }
  send(...t) {
    return super.send(...t);
  }
}
const F = (...e) => {
  const l = y.create();
  return l.component = g(), l.$watch = M, e.length && l.send(...e), l;
};
function k(e) {
  return function(...l) {
    const t = y.create();
    return t.component = e, t.$watch = M, l.length && t.send(...l), t;
  };
}
class A {
  constructor(l = null, t = null, c = null) {
    d(this, "window");
    d(this, "ray");
    d(this, "additionalInfoCallback", null);
    d(this, "onVueError", (l, t) => {
      const c = this.additionalInfoHtml(l, t, "vue"), n = l.stack.replace(
        /^(\w+):(.+)$/m,
        '<div class="flex bg-white border-0"><div class="flex-row bg-white text-red-400 pr-1 pl-1 border border-1 border-red-400">$1</div><div style="padding-top: 0.25em;" class="flex-row">$2</div></div>'
      ).replace(/\n/, `Stack Trace:
`).replace(/ at ([^ ]+) (.*)$/gm, '<div class="inline"> at <span class="text-blue-700">$1</span> $2</div>');
      t.$ray().sendCustom(`<pre>${n}${c}</pre>`, "Error").small().red();
    });
    d(this, "onWindowError", (l, t, c, n, r) => {
      var f;
      const a = this.additionalInfoHtml(r, { message: l, source: t, lineno: c, colno: n }, "error"), i = `
        <div class="flex bg-white border-0">
            <div class="flex-row bg-white text-red-400 pr-1 pl-1 border border-1 border-red-400">${l}</div>
            <div style="padding-top: 0.25em;" class="flex-row"><code>${t}</code></div>
        </div>${a}`;
      (f = this.ray) == null || f.html(`<pre>${i}</pre>`, "Error").small().red();
    });
    d(this, "onWindowUnhandledRejectionEvent", (l) => {
      var n;
      const t = this.additionalInfoHtml(null, l, "unhandled_rejection"), c = `
        <div class="flex bg-white border-0">
            <div class="flex-row bg-white text-red-400 pr-1 pl-1 border border-1 border-red-400">${l.reason}</div>
            <div style="padding-top: 0.25em;" class="flex-row"><code>${JSON.stringify(l)}</code></div>
        </div>${t}`;
      (n = this.ray) == null || n.html(`<pre>${c}</pre>`, "Error").small().red();
    });
    this.additionalInfoCallback = l, this.ray = c ?? o.methods.$ray(g()), this.window = t ?? globalThis;
  }
  additionalInfo(l, t, c) {
    return this.additionalInfoCallback ? this.additionalInfoCallback(l, t, c) : "";
  }
  additionalInfoHtml(l, t, c) {
    let n = this.additionalInfo(l, t, c);
    return typeof n == "string" && n.length === 0 ? "" : typeof n != "string" && typeof n != "number" ? (n = h(n, { indent: 4, highlight: !0 }), `<details open><summary class="text-black w-full block mt-1 cursor-pointer">Additional Info:</summary><div class="text-blue-600 w-full block pl-8">${n}</div></details>`) : `<div class="text-black w-full block mt-1">Additional Info:</div><div class="text-blue-600 w-full block pl-8">${n}</div>`;
  }
  installVueErrorHandler(l) {
    return l.errorHandler = this.onVueError, l;
  }
  installWindowErrorHandlers(l = null, t = null) {
    this.window && (this.window.onerror = l ?? this.onWindowError, this.window.unhandledrejection = t ?? this.onWindowUnhandledRejectionEvent);
  }
}
const b = new A(), z = (e, l) => {
  e = e || {}, typeof (e == null ? void 0 : e.interceptErrors) == "function" && (b.additionalInfoCallback = e == null ? void 0 : e.interceptErrors), ((e == null ? void 0 : e.interceptErrors) === !0 || typeof (e == null ? void 0 : e.interceptErrors) == "function") && (b.installVueErrorHandler(l), b.installWindowErrorHandlers());
  let t = "localhost", c = 23517, n = "http", r = null, a = null, i = null;
  const f = e.nodeRaySettings ?? {};
  e = Object.assign({ host: t, port: c, scheme: n, enabled_callback: r, sending_payload_callback: a, sent_payload_callback: i }, e), typeof e.host == "string" && (t = e.host), typeof e.port == "number" && (c = e.port), typeof e.scheme == "string" && (n = e.scheme), typeof e.enabled_callback == "function" && (r = e.enabled_callback), typeof e.sending_payload_callback == "function" && (a = e.sending_payload_callback), typeof e.sent_payload_callback == "function" && (i = e.sent_payload_callback), y.useDefaultSettings({
    host: t,
    port: c,
    scheme: n,
    enabled_callback: r,
    sending_payload_callback: a,
    sent_payload_callback: i,
    ...f
  });
}, G = {
  install: (e, l) => {
    N(e.config.globalProperties), z(l, e.config), e.provide("ray", l), e.$ray = k(e);
  }
};
function K(e = {}, l = null) {
  var c, n, r, a, i, f, w, v, $, p, E, x, R, S, _, I;
  l = l ?? g();
  const t = k(l);
  if (e || (e = {}), l.$ray = t, l.trackingRays = {}, l.trackingStops = {}, (c = e == null ? void 0 : e.connection) != null && c.host || (n = e == null ? void 0 : e.connection) != null && n.port) {
    const s = {};
    (r = e.connection) != null && r.port && (s.port = e.connection.port), (a = e.connection) != null && a.host && (s.host = e.connection.host), y.useDefaultSettings(s);
  }
  return e.lifecycleEvents = e.lifecycleEvents ?? {}, e.lifecycleEvents.all = ((i = e.lifecycleEvents) == null ? void 0 : i.all) ?? !1, ((f = e.lifecycleEvents) == null ? void 0 : f.all) === !0 && (e.lifecycleEvents.beforeMount = !0, e.lifecycleEvents.beforeUnmount = !0, e.lifecycleEvents.updated = !0, e.lifecycleEvents.mounted = !0, e.lifecycleEvents.unmounted = !0), (w = e.lifecycleEvents) != null && w.beforeMount && (((v = e.lifecycleMethods) == null ? void 0 : v.beforeMount) ?? C)(() => o.beforeMount(l, t())), ($ = e.lifecycleEvents) != null && $.beforeUnmount && (((p = e.lifecycleMethods) == null ? void 0 : p.beforeUnmount) ?? D)(() => o.beforeUnmount(l, t())), (E = e.lifecycleEvents) != null && E.updated && (((x = e.lifecycleMethods) == null ? void 0 : x.updated) ?? O)(() => o.updated(l, t())), (R = e.lifecycleEvents) != null && R.mounted && (((S = e.lifecycleMethods) == null ? void 0 : S.mounted) ?? W)(() => o.mounted(l, t())), (_ = e.lifecycleEvents) != null && _.unmounted && (((I = e.lifecycleMethods) == null ? void 0 : I.unmounted) ?? T)(() => o.unmounted(l, t())), V(l.$ray);
}
export {
  o as RayMixin,
  G as RayPlugin,
  y as VueRay,
  z as initializeOptions,
  F as ray,
  K as raySetup
};
